module.exports = "pegasus/assets/tech/welcome/101.png";